// extracted by css-extract-rspack-plugin
export default {"InsightsFilterBarContainer":"InsightsFilterBar-module__InsightsFilterBarContainer__Bsbgk","centeredFooterItem":"InsightsFilterBar-module__centeredFooterItem__tFN8b"};